module.exports = __webpack_public_path__ + "static/img/analysis1.17684c6d.png";